import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LegalShell } from "./privacy";

export const Route = createFileRoute("/refund")({
  component: RefundPage,
  head: () => ({
    meta: [
      { title: "Refund Policy — Business Dite Ads" },
      {
        name: "description",
        content:
          "Refund policy for Business Dite Ads subscriptions — billing, cancellation, refund window and how to request a refund.",
      },
      { property: "og:title", content: "Refund Policy — Business Dite Ads" },
      { property: "og:url", content: "https://busditeads.com/refund" },
      {
        property: "og:description",
        content: "Refund policy for Business Dite Ads subscriptions.",
      },
    ],
    links: [{ rel: "canonical", href: "https://busditeads.com/refund" }],
  }),
});

function RefundPage() {
  const { t } = useTranslation();
  return (
    <LegalShell>
      <article className="prose prose-sm max-w-none dark:prose-invert sm:prose-base">
        <p className="text-xs text-muted-foreground">{t("legal.lastUpdated")}: 2026-04-22</p>
        <h1>{t("legal.refund.title")}</h1>
        <p>{t("legal.refund.intro")}</p>

        <h2>{t("legal.refund.s1Title")}</h2>
        <p>{t("legal.refund.s1Body")}</p>

        <h2>{t("legal.refund.s2Title")}</h2>
        <p>{t("legal.refund.s2Body")}</p>

        <h2>{t("legal.refund.s3Title")}</h2>
        <p>{t("legal.refund.s3Body")}</p>

        <h2>{t("legal.refund.s4Title")}</h2>
        <p>
          {t("legal.refund.s4Body")}{" "}
          <a
            href="https://paddle.net/contact"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            paddle.net/contact
          </a>{" "}
          {t("legal.refund.orEmailUs")}{" "}
          <a href="mailto:contact@diteads.com" className="text-primary hover:underline">
            contact@diteads.com
          </a>
          .
        </p>

        <h2>{t("legal.refund.s5Title")}</h2>
        <p>{t("legal.refund.s5Body")}</p>
      </article>
    </LegalShell>
  );
}
